module.exports = __webpack_public_path__ + "static/media/folder-cfa.c504e9de.svg";